import {
  PAGE_NOT_FOUND_URL,
  ERROR_PAGE_URL
} from 'constant'

export const isNotFoundPage = (path) => path === PAGE_NOT_FOUND_URL || path === ERROR_PAGE_URL
